import { render, staticRenderFns } from "./Artists.vue?vue&type=template&id=c14a8784&"
import script from "./Artists.vue?vue&type=script&lang=js&"
export * from "./Artists.vue?vue&type=script&lang=js&"
import style0 from "./Artists.vue?vue&type=style&index=0&id=c14a8784&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports